import PropTypes from 'prop-types'
import {
  COMISION_POR_VENTA_TEXTO,
  COSTO_POR_PUBLICAR_TEXTO,
  esCobroPorPublicar,
  VIGENCIA_MENSUAL_TEXTO
} from '../../../constants/publicaciones.js'
import { formatearNumeroAR } from '../../helpers/formatearNumeroAR'
import medalExposicionOro from './img/exposicionOro.png'
import medalExposicionPlata from './img/exposicionPlata.png'
import medalExposicionPlatino from './img/exposicionPlatino.png'
import './ExposicionTipo.css'

const PLAN_PLATINO = 1
const PLAN_ORO = 2
const PLAN_PLATA = 3

const MEDALLAS = {
  [PLAN_PLATINO]: medalExposicionPlatino,
  [PLAN_ORO]: medalExposicionOro,
  [PLAN_PLATA]: medalExposicionPlata
}

const ExposicionTipo = (props) => {
  const { exposicion, name, checked, value, onChange, disabled, esPresupuesto } = props
  const esPorPublicar = esCobroPorPublicar(exposicion)
  const ocultarImporte = Boolean(esPresupuesto) && !esPorPublicar

  const obtenerClases = () => {
    const arrClases = ['btn btn-exposicionTipo']
    if (checked) {
      arrClases.push('clicked')
    }
    if (disabled) {
      arrClases.push('disabled')
    }
    return arrClases.join(' ')
  }

  const obtenerImagen = () => {
    const medalla = MEDALLAS[exposicion.idPublicacionExposicion]
    return medalla ? <img src={medalla} className="medal" alt={exposicion.nombre} /> : null
  }

  return (
    <div className="btn-group btn-group-toggle exposicionTipo-borde">
      <label className={obtenerClases()}>
        <input
          type="radio"
          name={name}
          checked={checked}
          value={value}
          onChange={onChange}
          disabled={disabled}
          aria-disabled={disabled}
        />
        <div className="text-center">{obtenerImagen()}</div>
        <h3 className="exposicionTipo-titulo">Exposición {exposicion.nombre}</h3>
        <div className="text-center">
          {!ocultarImporte && (
            <span className="size">
              <i className="fa fa-usd" aria-hidden="true" />
              {formatearNumeroAR(exposicion.montoCalculado)}
            </span>
          )}
          <div>
            {esPorPublicar ? (
              <span>
                {COSTO_POR_PUBLICAR_TEXTO} {VIGENCIA_MENSUAL_TEXTO}
              </span>
            ) : (
              !ocultarImporte && (
                <span>
                  {exposicion.precio}
                  {COMISION_POR_VENTA_TEXTO}
                </span>
              )
            )}
          </div>
        </div>
      </label>
    </div>
  )
}

ExposicionTipo.propTypes = {
  exposicion: PropTypes.shape({
    idPublicacionExposicion: PropTypes.number,
    nombre: PropTypes.string,
    descripcion: PropTypes.string,
    precio: PropTypes.number,
    tipoCobro: PropTypes.string,
    montoCalculado: PropTypes.number
  }).isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  esPresupuesto: PropTypes.bool
}

export default ExposicionTipo
